import { Division, JobTitle, MessageType, SystemMessage } from '@connect-x-app/shared-domain-models';

export type SystemMessageWithType = SystemMessage & {
  messageType: MessageType;
};

export const ALL_SYSTEM_MESSAGES_FUNCTIONS: JobTitle[] = [
  JobTitle.ADMINISTRATOR,
  JobTitle.CABIN_CREW,
  JobTitle.DISPATCHER,
  JobTitle.GROUND_HANDLER,
  JobTitle.MAINTENANCE_CREW,
  JobTitle.PILOT,
  JobTitle.UNKNOWN,
];

export enum ReceiverOptions {
  ALL_FUNCTIONS = 'ALL_FUNCTIONS',
  NO_FUNCTIONS = 'NO_FUNCTIONS',
  SPECIFIC_FUNCTIONS = 'SPECIFIC_FUNCTIONS',
}

export type FunctionListItem = {
  label: Division;
  value: JobTitle;
};

export type SystemMessageForm = {
  functions: FunctionListItem[];
  receiverOption: ReceiverOptions;
  timeBeforeInHours: string | number;
};

export type SubmitSystemMessageForm = {
  data: SystemMessage;
  messageType: MessageType;
};
